import { formatCash } from '../utils/numberFormat';
// import { useNavigation } from "@react-navigation/native"
import { useUserStore } from './stores/userStore';
import { PopupService } from 'react-ui-components/components/PopupService';
import {
  UsersCounterButtonView,
  UsersCounterDetailView,
} from 'react-ui-components/components/users';
import { useNamespacedTranslation } from '../hooks/useNamespacedTranslation';

export interface UsersCounterProps {
  style?: any;
  className?: string;
  size?: string;
  spaceBetween?: boolean;
  variant?: 'text' | 'outlined' | 'contained';
  left?: boolean;
}

export const UsersCounter = function UsersCounter(props: UsersCounterProps) {
  const {
    style,
    className,
    size = 'medium',
    spaceBetween,
    variant = 'contained',
    left = true,
  } = props;
  const $styles = { ...style, spaceBetween: spaceBetween };
  const { usersCount } = useUserStore();
  const { t } = useNamespacedTranslation(['common']);
  const safeUsersCount = Number(usersCount || 0);
  const compactCount = formatCash(safeUsersCount);
  const exactCount = safeUsersCount.toLocaleString();
  const title = t('registeredUsers');
  const communityLabel = t('winFacilCommunity');
  const description = t('registeredUsersDescription');
  const exactLabel = t('exactTotal');
  const helperText = t('usersCounterHelperText');
  const ariaLabel = t(
    'showRegisteredUsersExactTotal',
    `Show registered users. Exact total: ${exactCount}`,
    { exactCount },
  );

  return (
    <UsersCounterButtonView
      variant={variant}
      style={$styles}
      className={className}
      size={size}
      left={left}
      compactCount={compactCount}
      ariaLabel={ariaLabel}
      onClick={() => {
        PopupService.setPopup(
          <UsersCounterDetailView
            exactCount={exactCount}
            compactCount={compactCount}
            title={title}
            communityLabel={communityLabel}
            description={description}
            exactLabel={exactLabel}
            helperText={helperText}
          />,
          '',
          {
            maxWidth: 380,
            width: 'min(380px, 92vw)',
            contentStyle: { padding: 0 },
          },
        );
      }}
    />
  );
};
